"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeNumber = void 0;
const serializeNumber = (value) => {
    const parts = value.toFixed(3).split('.');
    const decimal = parts[1].replace(/0+$/, '');
    if (decimal) {
        const integer = parts[0].replace(/^0/, '');
        return `${integer}.${decimal}`;
    }
    return parts[0];
};
exports.serializeNumber = serializeNumber;
